export default function () {
  return {
    page: 1,
    totalPages: 0,
    perPage: 15,
    searchParams: {},
    items: [],
    showDeleteModal: false,
    deletingItem: null,
    fields: [
      {
        key: 'name',
        label: 'Nome'
      },
      {
        key: 'start',
        label: 'Início'
      },
      {
        key: 'end',
        label: 'Fim'
      },
      {
        key: 'actions',
        label: 'Ações'
      }
    ]
  }
}
